import { DataManager } from '../core/data-manager';
import { ResourceManager } from '../core/resource-manager';
import { settings } from './settings';

let cachedSettings = null;
let loadingPromise = null;
let insertingPromise = null;

function buildDefaults() {
    return {
        // data_print
        companyName: settings.data_print?.name || '',
        address: settings.data_print?.address || '',
        phone: settings.data_print?.phone || '',
        fax: settings.data_print?.fax || '',
        email: settings.data_print?.email || '',
        website: settings.data_print?.website || '',
        iva: settings.data_print?.iva || '',
        cf: settings.data_print?.cf || '',
        // dati_pagamento
        iban: settings.dati_pagamento?.iban || '',
        bic: settings.dati_pagamento?.bic || '',
        banca: settings.dati_pagamento?.banca || '',
        intestatario: settings.dati_pagamento?.intestatario || '',
        // dati_fattura
        statoPIVA: settings.dati_fattura?.statoPIVA || 'IT',
        PIVA: settings.dati_fattura?.PIVA || '',
        PIVAcompleta: settings.dati_fattura?.PIVAcompleta || '',
        codiceFiscale: settings.dati_fattura?.codiceFiscale || '',
        regimeFiscale: settings.dati_fattura?.regimeFiscale || 'RF01',
        denominazione: settings.dati_fattura?.denominazione || '',
        indirizzo: settings.dati_fattura?.indirizzo || '',
        cap: settings.dati_fattura?.cap || '',
        comune: settings.dati_fattura?.comune || '',
        provincia: settings.dati_fattura?.provincia || '',
        nazione: settings.dati_fattura?.nazione || 'IT',
        formatoTrasmissione: settings.dati_fattura?.formatoTrasmissione || 'FPR12',
        codiceDestinatario: settings.dati_fattura?.codiceDestinatario || '0000000',
        ufficio: settings.dati_fattura?.ufficio || '',
        numeroREA: settings.dati_fattura?.numeroREA || '',
        socioUnico: settings.dati_fattura?.socioUnico || '',
        statoLiquidazione: settings.dati_fattura?.statoLiquidazione || '',
        // logo
        logoPrint: null,
    };
}

function mergeSettings(dbRecord) {
    var defaults = buildDefaults();
    var merged = { ...defaults };
    for (var key in merged) {
        if (dbRecord[key] !== undefined && dbRecord[key] !== null && dbRecord[key] !== '') {
            merged[key] = dbRecord[key];
        }
    }
    return merged;
}

export const CompanySettingsProvider = {

    async load(forceReload) {
        if (cachedSettings && !forceReload) {
            return cachedSettings;
        }
        if (loadingPromise) {
            return loadingPromise;
        }
        loadingPromise = (async () => {
            try {
                var res = await DataManager.getItems('company_settings', 1, 1, { field: 'id', order: 'desc' });
                if (res.success === 1 && res.body && res.body.length > 0) {
                    cachedSettings = mergeSettings(res.body[0]);
                    cachedSettings._id = res.body[0].id;
                    cachedSettings._raw = res.body[0];
                } else {
                    // Nessun record: creiamo il primo con i default da settings.js
                    // Usiamo insertingPromise per evitare insert duplicati
                    if (!insertingPromise) {
                        var defaults = buildDefaults();
                        insertingPromise = DataManager.insertItem('company_settings', defaults);
                        var insertRes = await insertingPromise;
                        insertingPromise = null;
                        if (insertRes.success === 1 && insertRes.body && insertRes.body.id) {
                            cachedSettings = { ...defaults };
                            cachedSettings._id = insertRes.body.id;
                            cachedSettings._raw = defaults;
                        } else {
                            cachedSettings = defaults;
                        }
                    } else {
                        await insertingPromise;
                        cachedSettings = buildDefaults();
                    }
                }
            } catch (e) {
                console.warn('CompanySettingsProvider: fallback to defaults', e);
                insertingPromise = null;
                cachedSettings = buildDefaults();
            }
            loadingPromise = null;
            return cachedSettings;
        })();
        return loadingPromise;
    },

    get() {
        return cachedSettings || buildDefaults();
    },

    getLogoPrintUrl() {
        var cs = cachedSettings || {};
        if (cs._raw && cs._raw.logoPrint && cs._raw.logoPrint.hash) {
            return ResourceManager.getFileUrl(cs._raw.logoPrint, 'company_settings');
        }
        return null;
    },

    invalidateCache() {
        cachedSettings = null;
        loadingPromise = null;
    }
};
